import { Component, Injector, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AllDashboardServiceProxy, GetAllProjectDto, ProfileServiceProxy, ProjectDetailsDto, ProjectServiceProxy } from '../../../../../shared/service-proxies/service-proxies';

@Component({
    selector: 'app-dashboard-project-section',
    templateUrl: './dashboard-project-section.component.html',
    styleUrls: ['./dashboard-project-section.component.css']
})
export class DashboardProjectSectionComponent implements OnInit {

    constructor(private _profileService: ProfileServiceProxy,private _AllDashboardServiceProxy: AllDashboardServiceProxy, private router: Router, private _projectServiceProxy: ProjectServiceProxy ,injector: Injector) { }
    Loaded = false;
    Empty = true;
    projectDetails: ProjectDetailsDto[];
    myProfileData: string;
    isEmployee: boolean = false;

    ngOnInit(): void {

        // this._profileService.myProfileInfo().subscribe(res => {
        //     this.myProfileData = res.designation;
        //     if (this.myProfileData == 'Employee,') {
        //         this.isEmployee = true;
        //     }
        //     else {
        //         this.isEmployee = false;
        //     }
        // });
        this.getUserProjectdetails();
    }

    getUserProjectdetails() {
        this._projectServiceProxy.getUserWiseProjectDetails(5).subscribe(result => {
            this.projectDetails = [];
            
            result.forEach(x => {
              
                this.projectDetails.push(x);
                this.Empty = false;
            });
            this.Loaded = true;
           // console.log('XYZ', this.projectDetails);

        });

    }

    viewall(){
        this.router.navigate(['app/main/projects-new/projects-new-management']);
    }



    DisableTooltip(name: string, num: number) {
        return name?.length > num ? false : true;
    }

    //project progressbar calculation
     HoursLoggedBarCalculation(startD: Date, endD: Date) {
    if (!startD || !endD) return 0;
    let progressBar=0;
    var startDate = new Date(startD.toString());
    var endDate = new Date(endD.toString());
    const PresentDay = new Date();
            if( (startDate > endDate) || (startDate > PresentDay)){
                progressBar=0;
            }else if(PresentDay > endDate){
                progressBar=100;
            }else{
                progressBar = (PresentDay.getTime() - startDate.getTime())*100/(endDate.getTime() - startDate.getTime());
            }
            progressBar = Math.floor(progressBar);
            return progressBar;
    }
}
